import { render, staticRenderFns } from "./customizationsTable.vue?vue&type=template&id=4d10af27&scoped=true"
import script from "./customizationsTable.vue?vue&type=script&lang=js"
export * from "./customizationsTable.vue?vue&type=script&lang=js"
import style0 from "./customizationsTable.vue?vue&type=style&index=0&id=4d10af27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10af27",
  null
  
)

export default component.exports